import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { walletsBunja } from '@flipster/r230522/original/wallet';
import { Tooltip } from '@flipster/react/design-system-legacy/tooltip';
import { Dialog, dialog } from '@flipster/react/design-system/dialog';
import { IconButton } from '@flipster/react/design-system/icon-button';
import Formatted from '@flipster/react/design-utils/formatted';
import InformationCircleIcon from '@flipster/react/icon/generated/InformationCircleIcon';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';
import { PusdtCurrency, UsdCurrencyList, UsdPrecision, UsdtCurrency } from '@flipster/utils/constants/currency';

export const TotalBalance = ({ currency }: { currency: string }) => {
  const { walletsAtom } = useBunja(walletsBunja);
  const wallets = useAtomValue(walletsAtom);
  const balance = wallets?.[currency]?.walletBalanceExclWithdrawalPending ?? 0;
  const precision = UsdCurrencyList.includes(currency) ? UsdPrecision : 8;
  const displayCurrency = currency === PusdtCurrency ? UsdtCurrency : currency;

  const tooltipContents = (
    <ul className={css({ list: 'disc' })}>
      <li>
        <FormattedMessage id='Autogen_common.r251126.s_Displays_the_total_balance_of_selected_asset' />
      </li>
      <li>
        <FormattedMessage id='Autogen_common.r251126.s_Unrealized_PnL_is_not_included_in_the_Total_Balance' />
      </li>
    </ul>
  );

  return (
    <div
      className={hstack({
        h: 48,
        justify: 'space-between',
      })}
    >
      <div className={hstack()}>
        <span className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-5' })}>
          <FormattedMessage id='Autogen_common.r251126.s_Total_balance' />
        </span>
        <Tooltip
          placement='bottom'
          crossAxisOffset={75}
          maxWidth={500}
          mobileAlert={() =>
            dialog.open({
              title: {
                label: 'Total balance',
              },
              content: tooltipContents,
              buttons: {
                primary: <Dialog.Button hierarchy='primary' label='OK' />,
              },
            })
          }
        >
          <Tooltip.Trigger asChild>
            <IconButton icon={<InformationCircleIcon />} size='small' hierarchy='quaternary' />
          </Tooltip.Trigger>
          <Tooltip.Content>{tooltipContents}</Tooltip.Content>
        </Tooltip>
      </div>
      <Formatted.Number
        value={balance}
        toFixed
        precision={precision}
        suffix={displayCurrency}
        css={{ textStyle: 'Text/M/Monospace/Strong', color: 'content.default.level-5' }}
      />
    </div>
  );
};
